import React from 'lib/react';
import {
  EVGrid,
  makeStyles,
} from 'lib/components';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';

const useStyles = makeStyles(() => ({
  scrollableSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    overflowY: 'auto',
    position: 'relative',
  },
  scrollableSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'absolute',
    overflow: 'auto',
  },
}));

function ScrollableSectionComponent({
  children,
  className,
  containerClassName,
}) {
  const classes = useStyles();

  return (
    <EVGrid
      className={clsx(classes.scrollableSectionContainer, containerClassName)}
    >
      <EVGrid
        className={clsx(classes.scrollableSection, className)}
      >
        {children}
      </EVGrid>
    </EVGrid>
  );
}

ScrollableSectionComponent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
};

ScrollableSectionComponent.defaultProps = {
  className: undefined,
  containerClassName: undefined,
};

export default ScrollableSectionComponent;
